exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.main-chart {\r\n    width: 100%;\r\n    height:500px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/component/energy-storage-detail/energy-storage-detail.component.css
// module id = ../../../../../src/app/component/energy-storage-detail/energy-storage-detail.component.css
// module chunks = main